import type { FiltersSearchType } from '@/common/api/types/itemFilters';

export const ARCHIVED_BOOLEAN_FILTERS = [
  'showArchived',
] as const satisfies readonly (keyof FiltersSearchType)[];
